import axiosInstance from "../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const reciptVoucherURL = `api/v1/account-app/vouchermain`;

//obtaining the paginated data
export const getReciptVoucher = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${reciptVoucherURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}&voucherType=10`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllReciptVoucher = () => axiosInstance.get(`${reciptVoucherURL}/list?ordering=-id&voucherType=10`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageReciptVoucher = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${reciptVoucherURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}&voucherType=10`
  );

// get by id
export const getReciptVoucherById = (id) => axiosInstance.get(`${reciptVoucherURL}/retrieve/${id}`);

//creating function
export const createReciptVoucher = (body) => axiosInstance.post(`${reciptVoucherURL}/create`, body);
//creating function
export const createCostCenterDetails = (body) =>
  axiosInstance.post(`api/v1/cost-center/cost-center-details/create`, body);
//updating function
export const updateReciptVoucher = (id, body) => axiosInstance.patch(`${reciptVoucherURL}/update/${id}`, body);
// approve function
export const approveReciptVoucher = (id, body) => axiosInstance.patch(`${reciptVoucherURL}/approve/${id}`, body);
//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${reciptVoucherURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
